import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar, Clock, ChevronRight } from 'lucide-react';
import { BlogPost } from '../../types/blog';

interface RelatedArticlesProps {
    articles: BlogPost[];
}

export const RelatedArticles: React.FC<RelatedArticlesProps> = ({ articles }) => {
    if (articles.length === 0) return null;

    return (
        <section className="mt-16 pt-12 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">Articles connexes</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {articles.map((article, index) => (
                    <motion.article
                        key={article.slug}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                        className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                    >
                        <div className="relative">
                            <img
                                src={article.image}
                                alt={article.title}
                                loading="lazy"
                                className="w-full h-48 object-cover"
                            />
                            <div className="absolute top-4 left-4 bg-primary text-white text-xs font-medium py-1 px-3 rounded-full">
                                {article.category}
                            </div>
                        </div>

                        <div className="p-6">
                            <h3 className="text-lg font-semibold mb-2 line-clamp-2">{article.title}</h3>
                            <p className="text-gray-600 text-sm mb-4 line-clamp-2">{article.excerpt}</p>

                            <div className="flex flex-wrap gap-3 text-xs text-gray-500 mb-4">
                                <div className="flex items-center">
                                    <Calendar className="h-3 w-3 mr-1" />
                                    <span>{new Date(article.date).toLocaleDateString('fr-FR')}</span>
                                </div>
                                <div className="flex items-center">
                                    <Clock className="h-3 w-3 mr-1" />
                                    <span>{article.readTime} de lecture</span>
                                </div>
                            </div>

                            <Link
                                to={`/blog/${article.slug}/`}
                                className="text-primary font-medium hover:text-primary-light transition-colors flex items-center text-sm"
                            >
                                Lire l'article
                                <ChevronRight className="ml-1 h-4 w-4" />
                            </Link>
                        </div>
                    </motion.article>
                ))}
            </div>
        </section>
    );
};
